<script setup lang="ts">
import { ComboboxRoot, type ComboboxRootEmits, type ComboboxRootProps, useForwardPropsEmits } from 'reka-ui'
import { ref } from 'vue'

const properties = defineProps<ComboboxRootProps>()
const emits = defineEmits<ComboboxRootEmits>()

const forwarded = useForwardPropsEmits(properties, emits)

const comboboxRoot = ref<typeof ComboboxRoot | null>(null)

defineExpose({
  comboboxRoot,
})
</script>

<template>
  <ComboboxRoot v-bind="forwarded" ref="comboboxRoot">
    <slot />
  </ComboboxRoot>
</template>
